import React from "react";
import PropTypes from "prop-types";
import SideNav from "../../containers/SideNav";
import BloombergBanner from "../v3/bloomberg-banner/BloombergBanner";
import Footer from "../footer/Footer";

const AccountManagementLayout = ({ bloombergSiteUrl, location, history, children }) => {
    return (
        <React.Fragment>
            <BloombergBanner bloombergSiteUrl={ bloombergSiteUrl } pathname={ location.pathname } />
            <div className="account-management-layout">
                <div className="account-management-layout__nav-container">
                    <aside className="account-management-layout__nav">
                        <SideNav location={ location } bloombergSiteUrl={ bloombergSiteUrl } history={ history } />
                    </aside>
                    <main className="account-management-layout__content-container">
                        <div className="account-management-layout__content">
                            { children }
                        </div>
                    </main>
                </div>
                <Footer bloombergSiteUrl={ bloombergSiteUrl } />
            </div>
        </React.Fragment>
    );
};

AccountManagementLayout.propTypes = {
    bloombergSiteUrl: PropTypes.string.isRequired
};

export default AccountManagementLayout;
